// defines route path and pathname declaration
export const routePaths = {
  home: {
    path: "/home",
    pathName: "home"
  },
  applications: {
    electronicControlUnit: {
      path: "electronic-control-unit",
      pathName: "electronic-control-unit",
      children: {
        sentMessages: { path: "sent-messages", pathName: "electronic-control-unit.sent-messages" },
        receivedMessages: {
          path: "received-messages",
          pathName: "electronic-control-unit.received-messages"
        },
        assets: { path: "my-assets", pathName: "electronic-control-unit.assets" },
        jobs: { path: "process-logs", pathName: "electronic-control-unit.jobs" },
        connectors: { path: "my-connectors", pathName: "electronic-control-unit.connectors" },
        policies: { path: "my-policies", pathName: "electronic-control-unit.policies" }
      }
    },
    certificateManagement: {
      path: "certificate-management",
      pathName: "certificate-management",
      children: {
        publish: { path: "publish-certificate", pathName: "certificate-management.publish" },
        myCertificates: {
          path: "my-certificates",
          pathName: "certificate-management.my-certificates"
        },
        certificateDetails: {
          path: "my-certificates/:certificateId",
          pathName: "certificate-management.certificate-details"
        },
        sharedCertificates: {
          path: "shared-certificates",
          pathName: "certificate-management.shared-certificates"
        },
        sharedCertificateDetails: {
          path: "shared-certificates/:conversationId",
          pathName: "certificate-management.shared-certificate-details"
        },
        sites: { path: "sites", pathName: "certificate-management.sites" },
        discover: { path: "discover-certificates", pathName: "certificate-management.discover" },
        consumptionHistory: {
          path: "consumption-history",
          pathName: "certificate-management.consumption-history"
        },
        inboundRequests: {
          path: "inbound-requests",
          pathName: "certificate-management.inbound-requests"
        },
        outboundStatus: {
          path: "outbound-status",
          pathName: "certificate-management.outbound-status"
        },
        jobs: { path: "process-logs", pathName: "certificate-management.jobs" }
      }
    },
    pcfExchange: {
      path: "pcf-exchange",
      pathName: "pcf-exchange",
      children: {
        createOffer: { path: "create-offer", pathName: "pcf-exchange.create-offer" },
        discover: { path: "discover", pathName: "pcf-exchange.discover" },
        requests: { path: "data-requests", pathName: "pcf-exchange.requests" },
        history: { path: "exchange-history", pathName: "pcf-exchange.history" },
        jobs: { path: "process-logs", pathName: "pcf-exchange.jobs" }
      }
    },
    pcfExchangeV9: {
      path: "pcf-exchange-v9",
      pathName: "pcf-exchange-v9",
      children: {
        createOffer: { path: "create-offer", pathName: "pcf-exchange-v9.create-offer" },
        discover: { path: "discover", pathName: "pcf-exchange-v9.discover" },
        requests: { path: "data-requests", pathName: "pcf-exchange-v9.requests" },
        history: { path: "exchange-history", pathName: "pcf-exchange-v9.history" },
        aspects: { path: "aspects", pathName: "pcf-exchange-v9.aspects" },
        assets: { path: "my-assets", pathName: "pcf-exchange-v9.assets" },
        jobs: { path: "process-logs", pathName: "pcf-exchange-v9.jobs" }
      }
    },
    cyberSecurityKPIs: {
      path: "cyber-security-kpis",
      pathName: "cyber-security-kpis",
      children: {
        create: { path: "create-metrics", pathName: "cyber-security-kpis.create" },
        jobs: { path: "process-logs", pathName: "cyber-security-kpis.jobs" }
      }
    },
    pcfRequests: {
      path: "pcf-requests",
      pathName: "pcf-requests"
    },
    pcfExchangeHistory: {
      path: "pcf-exchange-history",
      pathName: "pcf-exchange-history"
    },
    blockNotifications: {
      path: "block-notifications",
      pathName: "block-notifications",
      children: {
        send: { path: "send", pathName: "block-notifications.send" },
        sentHistory: { path: "sent-history", pathName: "block-notifications.sent-history" },
        receivedHistory: {
          path: "received-history",
          pathName: "block-notifications.received-history"
        },
        jobs: { path: "process-logs", pathName: "block-notifications.jobs" }
      }
    },
    traceability: {
      path: "traceability",
      pathName: "traceability",
      children: {
        createOffer: { path: "create-offer", pathName: "traceability.create-offer" },
        discover: { path: "discover", pathName: "traceability.discover" },
        notifications: { path: "notifications", pathName: "traceability.notifications" },
        industryCoreNotifications: {
          path: "industry-core-notifications",
          pathName: "traceability.industry-core-notifications"
        },
        contractAgreements: {
          path: "my-contract-agreements",
          pathName: "traceability.contract-agreements"
        },
        exchangeHistory: { path: "exchange-history", pathName: "traceability.exchange-history" },
        jobs: { path: "process-logs", pathName: "traceability.jobs" }
      }
    }
  },
  // Every Advanced page lives under /advanced/<nav-name>
  advanced: {
    path: "/advanced",
    pathName: "advanced",
    children: {
      policies: { path: "my-policies", pathName: "policies" },
      contractAgreements: { path: "my-contract-agreements", pathName: "contract-agreements" },
      contractDefinitions: { path: "my-contract-definitions", pathName: "contract-definitions" },
      assets: { path: "my-assets", pathName: "assets-overview" },
      simulateOffers: { path: "simulate-data-offers", pathName: "simulate-offers" },
      connectors: { path: "my-connectors", pathName: "connectors" },
      processLogs: { path: "process-logs", pathName: "jobs" },
      uploadHistory: { path: "upload-history", pathName: "upload-history" },
      providerTwinBrowser: {
        path: "provider-twin-browser",
        pathName: "digital-twin-provider"
      },
      consumerTwinBrowser: {
        path: "consumer-twin-browser",
        pathName: "digital-twin-consume"
      }
    }
  }
}
